import React from 'react';

/*
 * GanttDateHeader — fila de cabecera con las columnas de fechas.
 *
 * Props:
 *   colsHeader       array    Columnas de días/semanas/meses. Cada item: { label, width, sub?, fds?, esHoy? }
 *   colsHeaderMonth? array    Cuando existe, añade una fila superior con grupos de meses: { label, width }
 *   totalAncho       number   Ancho total del canvas en px.
 *   hoyX             number   Posición en px del día de hoy dentro del canvas.
 *   hoyVisible       boolean  Si el marcador "HOY" entra dentro del rango visible.
 */
const GanttDateHeader = ({ colsHeader, colsHeaderMonth, totalAncho, hoyX, hoyVisible }) => {
    const twoLevel = !!colsHeaderMonth;

    const dayColumns = colsHeader.map((col, idx) => (
        <div
            key={idx}
            className={[
                'GanttChart__date-col',
                col.fds   ? 'GanttChart__date-col--fds' : '',
                col.esHoy ? 'GanttChart__date-col--hoy' : '',
            ].join(' ')}
            style={{ width: col.width, minWidth: col.width }}
        >
            {col.sub && <span className="GanttChart__date-sub">{col.sub}</span>}
            <span className="GanttChart__date-num">{col.label}</span>
        </div>
    ));

    return (
        <div className={`GanttChart__head-row${twoLevel ? ' GanttChart__head-row--two-level' : ''}`}>

            {/* Celda izquierda — esquina fija (sticky top + sticky left) */}
            <div className={`GanttChart__head-left${twoLevel ? ' GanttChart__head-left--two-level' : ''}`}>
                <span className="GanttChart__head-label">Nombre</span>
                <span className="GanttChart__head-label GanttChart__head-label--estado">Estado</span>
            </div>

            {/* Columnas de fechas */}
            <div
                className={`GanttChart__head-right${twoLevel ? ' GanttChart__head-right--two-level' : ''}`}
                style={{ width: totalAncho, minWidth: totalAncho }}
            >
                {twoLevel ? (
                    <>
                        {/* Fila superior: grupos de mes */}
                        <div className="GanttChart__head-months-row">
                            {colsHeaderMonth.map((col, idx) => (
                                <div
                                    key={idx}
                                    className="GanttChart__month-col"
                                    style={{ width: col.width, minWidth: col.width }}
                                >
                                    {col.label}
                                </div>
                            ))}
                        </div>
                        {/* Fila inferior: días individuales */}
                        <div className="GanttChart__head-days-row" style={{ position: 'relative' }}>
                            {dayColumns}
                            {hoyVisible && (
                                <div className="GanttChart__hoy-tag" style={{ left: hoyX }}>HOY</div>
                            )}
                        </div>
                    </>
                ) : (
                    <>
                        {dayColumns}
                        {hoyVisible && (
                            <div className="GanttChart__hoy-tag" style={{ left: hoyX }}>HOY</div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default GanttDateHeader;
